const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaCliente: [],
	listaEndereco: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'LIMITE_CREDITO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'LIMITE_CREDITO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'LIMITE_CREDITO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'LIMITE_CREDITO_CLIENTE_SELECT_LISTADO':
            return {
				...state,
				listaCliente: action.payload.data
			};

		case 'LIMITE_CREDITO_ENDERECO_SELECT_LISTADO':
            return {
				...state,
				listaEndereco: action.payload.data
			};

        default:
            return state;
    }
}
